import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { LoginService } from '../../shared/services/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {
  isGuestUserEnabled: boolean;
  isRequesting: boolean;
  userId: string;
  password: string;
  validationSummary: string;
  returnUrl: string;
  robots: string;
  @Output()
  change = new EventEmitter<boolean>();
  @ViewChild('focusInput') focusInputElement: ElementRef;

  tempReturnUrl: string;

  constructor(private loginService: LoginService, private activatedRoute: ActivatedRoute, private router: Router) {
    this.isGuestUserEnabled = false;
    this.loadSettings();

    if (this.activatedRoute.snapshot.queryParamMap.get('u')) {
      this.userId = (this.activatedRoute.snapshot.queryParamMap.get('u') || '').toLowerCase();
    }
  }

  ngOnInit() {
    this.returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'] || '/';
  }

  ngAfterViewInit(): void {
    // check if user already logged in
    if (this.loginService.isUserLoggedIn()) {
      this.router.navigate(['/']);
    }

    if (this.focusInputElement) {
      this.focusInputElement.nativeElement.focus();
    }
    this.loginService.getServerVariablesUrl().subscribe((vars: any) => {
      this.isGuestUserEnabled = vars.isGuestUserEnabled;
    }, err => {
      this.isGuestUserEnabled = false;
    }
    );
  }

  login(): void {
    if (this.robots) {
      return;
    }
    this.validationSummary = '';
    if (this.disableCommit) {
      this.validationSummary = 'Please fill all the required fields.';
      return;
    }
    // if (!this.returnUrl || this.returnUrl === '/') {
    //   this.returnUrl = '/sdai';
    // }
    this.isRequesting = true;
    this.loginService.login(this.userId, this.password, this.loginOkCb.bind(this), this.loginErrorCb.bind(this));
  }

  loadSettings(): void {
    const me: any = this;
    this.loginService.loadSettings().subscribe((vars: any) => {
      me.applicationOfflineWarningMsg = vars.applicationOfflineWarningMsgText;
      me.isApplicationOffline = vars.isApplicationOffline;
      me.applicationOfflineMsgText = vars.applicationOfflineMsgText;
      me.showApplicationOfflineWarningMessage = vars.showApplicationOfflineWarningMessage;
      if (me.isApplicationOffline) {
        me.router.navigate(['/offline']);
      }
    }, err => {
      console.log(err);
    }
    );
  }

  loginOkCb(ok: boolean): void {
    this.isRequesting = false;
    if (typeof (ok) === 'boolean') {
      this.change.emit(ok);
      if (!ok) {
        this.denyLogin();
      }
    }
    this.router.navigate([this.loginService.isSystemAdminUserLoggedIn() ? '/registrations' : this.returnUrl]);
  }

  loginErrorCb(err: HttpErrorResponse): void {
    this.isRequesting = false;
    this.denyLogin((err.error.err.name === 'TooManyAttemptsError' || err.error.err.name === 'AccountNotApproved') ? err.error.err.message : '');
  }

  private denyLogin(message?: string) {
    this.validationSummary = message ? message : 'Invalid email or password';
  }

  register(): void {
    this.router.navigate(['/register']);
  }

  forgotPassword(): void {
    this.router.navigate(['/forgot_password']);
  }

  loginWithGuestUser(route: string): void {
    this.tempReturnUrl = '/' + route;
    this.loginService.guestLogin(this.guestLoginOkCb.bind(this), this.guestLoginErrorCb.bind(this));
  }

  guestLoginOkCb(ok: boolean): void {
    if (typeof (ok) === 'boolean') {
      if (!ok) {
        this.validationSummary = 'Error occurred while logging in guest user.';
      }
    }
    this.router.navigate([this.tempReturnUrl]);
  }

  guestLoginErrorCb(err: HttpErrorResponse): void {
    this.validationSummary = err.error.message;
  }

  cancel() {
    this.router.navigate(['/guestuser']);
  }

  get disableCommit(): boolean {
    return !this.userId || !this.password;
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-users/login/login.component.ts